import React, { useEffect, useState } from 'react';
import _ from 'lodash';

import CellContent from './CellContent';
import {
  FormElement,
  FormList,
  FormListItem,
} from '../../CommonFormComponents';
import { Confirmation } from '../../modals/common';
import { messageUtility } from '../../../utilities/messageUtility';
import { getErrorValidateWithId } from '../../../utilities/works';

const OxygenLackTemplate = ({
  context,
  grid,
  msgValidate,
  handlePushParam,
  column,
  tabKeyStatus,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [workUpper, setWorkUpper] = useState('');
  const [workLower, setWorkLower] = useState('');
  const [completeUpper, setCompleteUpper] = useState('');
  const [completeLower, setCompleteLower] = useState('');
  const { isAbortedOrApproved } = context.item;

  const handleSetData = () => {
    const v = grid.collectionView;
    v.editItem(v.currentItem);
    v.currentItem['oxygen_lack_dangerous_work_upper'] = workUpper;
    v.currentItem['oxygen_lack_dangerous_work_lower'] = workLower;
    v.currentItem['oxygen_lack_education_complete_upper'] = completeUpper;
    v.currentItem['oxygen_lack_education_complete_lower'] = completeLower;
    if (!v.currentItem['is_data_changed']['oxygen_lack']) {
      v.currentItem['is_data_changed']['oxygen_lack'] = true;
    }
    v.commitEdit();
    handlePushParam(context.item);
    setShowModal(false);
  };

  const getError = () => {
    const oxygenLackFields = [
      'oxygen_lack_dangerous_work_upper',
      'oxygen_lack_dangerous_work_lower',
      'oxygen_lack_education_complete_upper',
      'oxygen_lack_education_complete_lower',
    ];
    let message = '';
    _.forEach(oxygenLackFields, field => {
      message = getErrorValidateWithId(msgValidate, context.item, field);
      if (message) {
        return false;
      }
    });
    return message;
  };

  const renderContent = () => (
    <FormList>
      <FormListItem label='酸素欠乏危険作業主任者'>
        <FormElement>
          <div>
            <div className='OxygenLackModal__input'>
              <label htmlFor='oxygen_lack_dangerous_work_upper'>1行目</label>
              <input
                type='text'
                id='oxygen_lack_dangerous_work_upper'
                value={workUpper}
                maxLength={62}
                onChange={e => setWorkUpper(e.target.value)}
              />
            </div>
            <div className='OxygenLackModal__input'>
              <label htmlFor='oxygen_lack_dangerous_work_lower'>2行目</label>
              <input
                type='text'
                id='oxygen_lack_dangerous_work_lower'
                value={workLower}
                maxLength={62}
                onChange={e => setWorkLower(e.target.value)}
              />
            </div>
          </div>
        </FormElement>
      </FormListItem>
      <FormListItem label='特別教育修了者'>
        <FormElement>
          <div>
            <div className='OxygenLackModal__input'>
              <label htmlFor='oxygen_lack_education_complete_upper'>
                1行目
              </label>
              <input
                type='text'
                id='oxygen_lack_education_complete_upper'
                value={completeUpper}
                maxLength={62}
                onChange={e => setCompleteUpper(e.target.value)}
              />
            </div>
            <div className='OxygenLackModal__input'>
              <label htmlFor='oxygen_lack_education_complete_lower'>
                2行目
              </label>
              <input
                type='text'
                id='oxygen_lack_education_complete_lower'
                value={completeLower}
                maxLength={62}
                onChange={e => setCompleteLower(e.target.value)}
              />
            </div>
          </div>
        </FormElement>
      </FormListItem>
    </FormList>
  );

  useEffect(() => {
    setWorkUpper(_.get(context, 'item.oxygen_lack_dangerous_work_upper') || '');
    setWorkLower(_.get(context, 'item.oxygen_lack_dangerous_work_lower') || '');
    setCompleteUpper(
      _.get(context, 'item.oxygen_lack_education_complete_upper') || ''
    );
    setCompleteLower(
      _.get(context, 'item.oxygen_lack_education_complete_lower') || ''
    );
  }, [showModal]);

  return (
    <CellContent
      isDataChanged={_.get(context, `item.is_data_changed.oxygen_lack`)}
      errorMsg={getError()}
      errorTooltipId={`cell_${_.get(context, 'col.index')}_${_.get(
        context,
        'row.index'
      )}`}
      key={`${column}_${_.get(context, 'item.id')}`}
    >
      <button
        className={[
          isAbortedOrApproved ? 'btn-fixedsize--disabled' : '',
          'btn-fixedsize--sub btn-dialog',
        ].join(' ')}
        onClick={() => {
          setShowModal(true);
        }}
        tabIndex={tabKeyStatus}
      >
        酸欠を変更
      </button>
      <Confirmation
        visible={showModal}
        title='酸欠'
        negativeButtonClassName={'btn--effective'}
        message={renderContent()}
        confirmButtonText='保存'
        cancelButtonText={messageUtility.getMessage('I-000-017')}
        onCancel={() => setShowModal(false)}
        onConfirm={handleSetData}
        rootClassName='dialog--wide OxygenLackModal'
      />
    </CellContent>
  );
};

export default OxygenLackTemplate;



// WEBPACK FOOTER //
// ./src/components/wijimo/templates/OxygenLackTemplate.jsx